var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{staticClass:"c-external-link-icon",attrs:{"href":_vm.url,"rel":"noopener noreferrer","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.open($event)}}},[_vm._v("配送状況を確認する")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }